
	// @ts-nocheck
	import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import SearchModal from '@/components/modals/SearchModal.vue';
	import PatientRow from '@/components/patient-list/PatientRow.vue';
	import { Observer } from 'mobx-vue';
	import { autorun, IReactionDisposer } from 'mobx';
	import { Order, Pagination, Patient } from '@/store/engine/openapi/generated';
	import UtilsStore from '@/store/utilsStore';

	export type ProgressInfo = {
		message: 'Your data is still being fetched. Progress: ';
		percentDone: string;
		updateNeeded: boolean;
	};

	@Observer
	@Component({
		components: { SearchModal, DualButtonModal, Loading, PatientRow },
		filters: {
			fixedLength(val: string) {
				return val.length >= 43 ? val.slice(0, 40) + '...' : val;
			}
		}
	})
	export default class PatientTable extends Vue {
		@Prop() private privacy = false;
		@Prop() private patients: Patient[];
		@Prop() private tab;

		private loading = false;
		private patientChosen = false;
		private started = false;

		private patientDelete(patient: Patient) {
			this.$emit('patientDelete', patient);
			// this.filterPatientByOption(this.filter);
		}

		@Watch('filter')
		private onFilterChanged(filter: string) {
			// this.filterPatientByOption(filter);
		}

		async activated() {
			this.$state.biometric.clear();
			await this.$state._patient.clear();
			this.patientChosen = false;
			this.started = false;
		}

		public async patientFlowSkip(patient: Patient) {
			this.$emit('patientClick', patient);
		}
	}
